import { UserActionCode } from 'graphql/generated';

export const UserActionCodeValues: { [key in UserActionCode]: string } = {
  alreadyExists: 'Email address already registered',
  checked: 'User Checked',
  created: 'User created',
  deleted: 'User deleted',
  emailAlreadyVerified: 'Email address already verified',
  invalidVerificationCode: 'Invalid verification code',
  invalidPassword: 'Invalid password',
  loggedIn: 'User logged in',
  notFound: 'User not found',
  passwordChanged: 'Password changed',
  resetCodeSent: 'Reset code sent',
  success: 'Success',
  verificationCodeSent: 'Verification code sent',
  verified: 'User verified',
};
